import { Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { ChangeEvent } from 'react';
import { DynamicIcon } from 'src/components';
import { NotificationChannelResponse } from 'src/graphql/entities/notification-preference';
import { notificationChannelToConfigMap } from 'src/pages/Settings/notifications/utils';

export type NotificationChannelSelectProps = {
  channel: NotificationChannelResponse;
  checked: boolean;
  onChange: (event: ChangeEvent, checked: boolean) => void;
};

export const NotificationChannelSelect = ({
  channel,
  checked,
  onChange,
}: NotificationChannelSelectProps) => {
  return (
    <FormControlLabel
      key={channel.id}
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          size="small"
          sx={{
            padding: '0.3rem',
          }}
        />
      }
      label={
        <Stack direction="row" gap={0.5}>
          <DynamicIcon
            name={notificationChannelToConfigMap.get(channel.id)?.icon ?? 'notifications'}
            sx={{
              fontSize: '22',
            }}
          />
          <Typography variant="body2">{channel.name}</Typography>
        </Stack>
      }
    />
  );
};
